<div *ngIf="!ticket.reject" class="notifications">
  <div class="content">
    <ng-content select="[notification-content]"></ng-content>
  </div>
  <a *ngIf="isDismissible" class="close-button" (click)="close()">
    <span class="fa fa-times"></span>
  </a>
</div>
